import React from 'react';
import styled from 'styled-components';
import {useDiscounts} from '../../backend-services/Campaigns/hooks/useDiscounts';
import {
  CAMPAIGN_BANNER_HEIGHT,
  DESKTOP_STICKY_HEIGHT,
  META_BAR_HEIGHT,
  NAVIGATION_HEIGHT,
  USP_BANNER_HEIGHT,
} from '../../backend-services/Header/constants';

export const HeightCalcWrapper: React.FC<
  React.PropsWithChildren<{className?: string}>
> = ({children, className}) => {
  const hasAnyDiscounts = !!useDiscounts().data?.discount;

  return (
    <Section
      className={className}
      campaignBannerHeight={hasAnyDiscounts ? CAMPAIGN_BANNER_HEIGHT : 0}
    >
      {children}
    </Section>
  );
};

const Section = styled.section<{
  campaignBannerHeight: number;
}>`
  --layout-header-height: ${({campaignBannerHeight}) =>
    META_BAR_HEIGHT +
    DESKTOP_STICKY_HEIGHT +
    NAVIGATION_HEIGHT +
    USP_BANNER_HEIGHT +
    campaignBannerHeight}px;
`;
